const computeMemberOnlyLabel = (
  associations: string[],
  organizations: string[]
) => {
  const associationsLabel =
    associations.length === 1 ? 'association' : 'associations';
  const orgsLabel =
    organizations.length === 1 ? 'organization' : 'organizations';

  return `${associations.length} ${associationsLabel} + ${organizations.length} ${orgsLabel}`;
};

export default computeMemberOnlyLabel;
